import { BenefitDTO, BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { BENEFIT_PICTURES } from 'probonio-shared-ui/component/button';
import {
  BenefitListItemExtensionInterface,
  BenefitListItemProps,
} from '../../../extension/interface/benefit-list-item.extension.interface';
import { getBenefitIcon } from '../../benefit/BenefitIcon';

export class DiscountCodeBenefitListItemExtension extends BenefitListItemExtensionInterface {
  isHidden(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[], context?: Record<string, unknown>): boolean {
    return false;
  }

  getListItemProps(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[]): BenefitListItemProps {
    return {
      icon: getBenefitIcon(BenefitDTOBenefitEnum.DiscountCode),
      titleKey: `benefit.${BenefitDTOBenefitEnum.DiscountCode}.name`,
      navigateTo: '/discount-code',
      picture: BENEFIT_PICTURES[BenefitDTOBenefitEnum.DiscountCode],
      descriptionKey: `benefitModule:benefit.${BenefitDTOBenefitEnum.DiscountCode}.description`,
      benefitProgress: 100,
    };
  }
}
